import {detectTextDirection} from "../../utils/detectTextDirection";
import {formatTextSigns} from "../../utils/formatTextSigns";
import {formatTimeNoDate} from "../../utils/friendlyDate";
import {StatusView} from "../messages/StatusView";
import React from "react";
import {CONVERSATION_VIEWS} from "./Conversations";
import {ConversationMessage} from "../../types/ConversationMessage";
import {ConversationRow, Segment, SegmentMessage} from "../../types/ConversationProps";
import ConversationMessageMedia from "./conversationMessageMedia/ConversationMessageMedia";

interface ConversationMessageBubbleProps {
    message: ConversationMessage;
    onDemoMessageButtonClick: () => void;
}

const ConversationMessageBubble = ({ message, onDemoMessageButtonClick }: ConversationMessageBubbleProps) => {
    const media = message.media;
    return (
        <div className={`message-bubble-container ${message.sentByClient ? '' : 'shop'}`}>
            <div className="message-bubble">
                {message.imageUrl ? <ConversationMessageMedia text="Product Image" mediaUrl={message.imageUrl} /> : null}
                {message.media ? <ConversationMessageMedia text={message.content} media={message.media} /> : null}
                <span className={`message-content-text ${detectTextDirection(message.content)}`}>{formatTextSigns(message.content)}</span>
                <div className="message-time-and-status">
                    <div className="message-time">{formatTimeNoDate(new Date(message.time))}</div>
                    {!message.sentByClient ? <div className="message-status"><StatusView value={message.status || 'UNKNOWN'} errorMessage={message.errorMessage} isInBubble={true} /></div> : null}
                </div>
                {message.messageHistoryId ? <div className="whatsapp-demo-buttons">
                    <div className="whatsapp-demo-button" onClick={onDemoMessageButtonClick}>Complete Your Purchase</div>
                    <div className="whatsapp-demo-button" onClick={onDemoMessageButtonClick}>Opt-out from this order</div>
                </div> : null}
            </div>
        </div>
    );
}

export default ConversationMessageBubble;